// SVG placeholder images to replace external Unsplash URLs

const CLOUDINARY_DESTINATIONS = {
  marrakech:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773760319/nouzha/ubllqf3hfvqox1qixeby.jpg",
  fes:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773759766/nouzha/fes-20260317-new.jpg",
  sahara:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773759769/nouzha/sahara-20260317-new.jpg",
  chefchaouen:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766008/nouzha/destination-chefchaoun-20260317.jpg",
  casablanca:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766011/nouzha/destination-tangerrabat-20260317.jpg",
  essaouira:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773768781/nouzha/destination-essaouira-20260317.jpg",
    
  agadir:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766002/nouzha/destination-agadir-20260317.jpg",
  ouarzazate:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766005/nouzha/destination-ourzazate-20260317.jpg",
  tinghir:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766006/nouzha/destination-tinghir-20260317.jpg",
  elJadida:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766009/nouzha/destination-jadida-20260317.png",
  tangerRabat:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773766011/nouzha/destination-tangerrabat-20260317.jpg",
  ifrane:
    "https://res.cloudinary.com/dzszitsgb/image/upload/v1773767211/nouzha/destination-ifrane-20260317.jpg",
};

// =====================================================================
// 🌟 ESPACES POUR LES AUTRES PAGES (CLIQUER ET REMPLACER LES LIENS) 🌟
// =====================================================================
export const CLOUDINARY_SERVICES = {
  // Page Services / Headers / Cartes
  riads: CLOUDINARY_DESTINATIONS.marrakech, // Ex: "https://res.cloudinary.com/..."
  circuits: CLOUDINARY_DESTINATIONS.sahara,
  carRental: CLOUDINARY_DESTINATIONS.agadir,
  transport: CLOUDINARY_DESTINATIONS.casablanca,
  guidedTours: CLOUDINARY_DESTINATIONS.chefchaouen,
};

export const CLOUDINARY_BANNERS = {
  // Bannières pour les autres pages
  aboutPageHero: CLOUDINARY_DESTINATIONS.essaouira,
  contactPageHero: CLOUDINARY_DESTINATIONS.fes,
  servicesPageHero: CLOUDINARY_DESTINATIONS.ouarzazate,
  circuitsPageHero: CLOUDINARY_DESTINATIONS.tinghir,
};





// Service/Destination placeholder with Morocco-themed colors
export const createServicePlaceholder = (width = 400, height = 300, iconText = 'SERVICE') => {
  const svgContent = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#f97316;stop-opacity:0.8" />
          <stop offset="100%" style="stop-color:#ea580c;stop-opacity:0.9" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#grad1)"/>
      <circle cx="50%" cy="40%" r="30" fill="rgba(255,255,255,0.2)"/>
      <text x="50%" y="65%" font-family="Arial, sans-serif" font-size="16" font-weight="bold" fill="white" text-anchor="middle" dominant-baseline="middle">${iconText}</text>
    </svg>
  `;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

// Profile placeholder for testimonials
export const createProfilePlaceholder = (size = 60) => {
  const svgContent = `
    <svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="profileGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#f59e0b;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#d97706;stop-opacity:1" />
        </linearGradient>
      </defs>
      <circle cx="50%" cy="50%" r="${size/2}" fill="url(#profileGrad)"/>
      <circle cx="50%" cy="40%" r="${size/6}" fill="white"/>
      <path d="M${size*0.25} ${size*0.75} Q${size*0.5} ${size*0.6} ${size*0.75} ${size*0.75}" fill="white"/>
    </svg>
  `;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

// Hotel placeholder
export const createHotelPlaceholder = (width = 400, height = 300) => {
  const svgContent = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="hotelGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#fbbf24;stop-opacity:0.8" />
          <stop offset="100%" style="stop-color:#f59e0b;stop-opacity:0.9" />
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" fill="url(#hotelGrad)"/>
      <rect x="35%" y="25%" width="30%" height="50%" fill="rgba(255,255,255,0.3)" rx="5"/>
      <text x="50%" y="65%" font-family="Arial, sans-serif" font-size="16" font-weight="bold" fill="white" text-anchor="middle" dominant-baseline="middle">HOTEL</text>
    </svg>
  `;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};

// Predefined placeholders for specific services
export const servicePlaceholders = {
  riads: CLOUDINARY_SERVICES.riads || createServicePlaceholder(400, 300, 'RIADS'),
  circuits: CLOUDINARY_SERVICES.circuits || createServicePlaceholder(400, 300, 'CIRCUITS'),
  carRental: CLOUDINARY_SERVICES.carRental || createServicePlaceholder(400, 300, 'CAR RENTAL'),
  transport: CLOUDINARY_SERVICES.transport || createServicePlaceholder(400, 300, 'TRANSPORT'),
  guidedTours: CLOUDINARY_SERVICES.guidedTours || createServicePlaceholder(400, 300, 'GUIDED TOURS'),
};

// Predefined placeholders for destinations
export const destinationPlaceholders = {
  marrakech: CLOUDINARY_DESTINATIONS.marrakech,
  fez: CLOUDINARY_DESTINATIONS.fes,
  casablanca: CLOUDINARY_DESTINATIONS.casablanca,
  sahara: CLOUDINARY_DESTINATIONS.sahara,
  chefchaouen: CLOUDINARY_DESTINATIONS.chefchaouen,
  essaouira: CLOUDINARY_DESTINATIONS.essaouira,
  agadir: CLOUDINARY_DESTINATIONS.agadir,
  ouarzazate: CLOUDINARY_DESTINATIONS.ouarzazate,
  tinghir: CLOUDINARY_DESTINATIONS.tinghir,
  elJadida: CLOUDINARY_DESTINATIONS.elJadida,
  tangerRabat: CLOUDINARY_DESTINATIONS.tangerRabat,
  ifrane: CLOUDINARY_DESTINATIONS.ifrane,
};

// Profile placeholders for testimonials
export const profilePlaceholders = {
  sarah: createProfilePlaceholder(60),
  pierre: createProfilePlaceholder(60),
  emma: createProfilePlaceholder(60),
  female1: createProfilePlaceholder(60),
  male1: createProfilePlaceholder(60),
  female2: createProfilePlaceholder(60),
};

// Hotel placeholder
export const hotelPlaceholder = createHotelPlaceholder(400, 300);
export const hotelDetailPlaceholder = createHotelPlaceholder(1200, 500);